// @flow
import React from 'react';
import L from 'components/Loadable';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';

import AppBar from 'components/AppBar';
import HUD from 'components/HUD';
import Map from 'components/Map';

import ErrorMessage from 'components/ErrorMessage';
import SearchResultsDialog from 'components/SearchResultsDialog';
import NotamDetailsDialog from '../NotamDetailsDialog';
import CoordinateInputDialog from 'components/CoordinateInputDialog';

import CookieDisclaimer from 'components/CookieDisclaimer';
import DrawToolbar from 'components/DrawToolbar';

import MapLayerDrawer from 'components/MapLayerDrawer';
import MapLayerDrawerButton from 'components/MapLayerDrawer/MapLayerDrawerButton';

import DNDOverlay from 'components/DNDOverlay';

function getStyles({ browser, isSearch }) {
  const isMobile = browser.lessThan.medium;

  return {
    fab: {
      position: isMobile ? 'fixed' : 'absolute',
      bottom: isMobile ? (isSearch ? 90 : 12) : -24,
      right: 12,
      zIndex: 2,
    },

    legalInfoBtn: {
      position: 'fixed',
      padding: 6,
      lineHeight: '12px',
      fontFamily: 'Roboto Condensed, sans-serif',
      fontSize: 10,
      bottom: 20,
      left: 140,
    },

    fbLike: {
      position: 'fixed',
      padding: 5,
      bottom: 24,
      left: 12,
    },

    mapLayerDrawerButton: {
      position: 'absolute',
      top: 96,
      right: 24,
      zIndex: 1301,
    },
  };
}

const LoadableIntroTour = L(
  () =>
    import(/* webpackChunkName: 'tours' */
    'components/IntroTour'),
  { useSpinner: false }
);
const LoadableHUDTour = L(
  () =>
    import(/* webpackChunkName: 'tours' */
    'components/HUDTour'),
  { useSpinner: false }
);
const LoadableDrawToolsTour = L(
  () =>
    import(/* webpackChunkName: 'tours' */
    'components/DrawToolsTour'),
  { useSpinner: false }
);
const LoadableRTTour = L(
  () =>
    import(/* webpackChunkName: 'tours' */
    'components/RTTour'),
  { useSpinner: false }
);

const TOURS_ENABLED = false;

export default ({
  browser,
  appInDrawMode,
  mobileLocationSearchShown,
  drawToolsTourSeen,
  introTourSeen,
  hudOpen,
  hudTourSeen,
  rtTourSeen,

  toggleHUD,
  toggleMapLayerDrawer,
  mapLayerDrawerOpen,
  selectedFeature,
  hasSubscription,
}) => {
  const styles = getStyles({
    browser,
    isSearch: selectedFeature && selectedFeature.type === 's',
  });

  return (
    <DNDOverlay>
      {TOURS_ENABLED && hasSubscription && !(
        introTourSeen ||
        appInDrawMode ||
        mobileLocationSearchShown ||
        hudOpen
      ) && <LoadableIntroTour />}
      {TOURS_ENABLED && hasSubscription && !hudTourSeen && hudOpen && !appInDrawMode && <LoadableHUDTour />}
      {TOURS_ENABLED && hasSubscription && !drawToolsTourSeen && appInDrawMode && <LoadableDrawToolsTour />}

      {hasSubscription && <AppBar />}
      <Map />
      {hasSubscription && <HUD />}

      {hasSubscription && <ErrorMessage />}
      {hasSubscription && <SearchResultsDialog />}
      {hasSubscription && <NotamDetailsDialog />}
      {hasSubscription && <CoordinateInputDialog />}

      {hasSubscription && browser.lessThan.medium && !appInDrawMode ? (
        <FloatingActionButton
          className="intro-tour__step-2"
          style={styles.fab}
          onClick={() => toggleHUD(true)}
        >
          <FontIcon className="material-icons">add_location</FontIcon>
        </FloatingActionButton>
      ) : null}

      {hasSubscription && <MapLayerDrawer />}
      {hasSubscription && <MapLayerDrawerButton
        style={styles.mapLayerDrawerButton}
        onClick={() => toggleMapLayerDrawer(!mapLayerDrawerOpen)}
      />}

      {hasSubscription && <div
        className="fb-like"
        style={styles.fbLike}
        data-href="https://facebook.com/legter.hu/"
        data-layout="button_count"
        data-action="like"
        data-show-faces="false"
        data-size="small"
        data-share="true"
      />}

      <CookieDisclaimer />
      {hasSubscription && <DrawToolbar />}
    </DNDOverlay>
  );
};



// WEBPACK FOOTER //
// ./components/AppContainer/AppContainer.js